export default {
  isochrones: {
    isochrones: 'Izocronii',
    isochronesReady: 'Isocroni gata',
    calculatingIsochrones: 'Calcularea izocronilor ...',
    itWasNotPossibleToCalculateIsochronesWithTheDefinedOptions: 'Nu a fost posibil să se calculeze izocronele cu opțiunile definite. Încercați să definiți izocrone mai mici.',
    couldResolveTheSelectedPlaceAsASuitableCenter: 'Nu a fost posibilă rezolvarea punctului selectat ca fiind un centru adecvat.',
    apiError: {
      2003: 'Suprafața unui poligon de evitat nu trebuie să depășească 20,0000 kilometri pătrați.',
      3001: 'Unul sau mai mulți parametri au o valoare sau un format incorect.',
      3003: 'Parametrul "avoid_features" are valoarea incorectă "null"',
      3004: 'Combinația de profil, interval și timp sau distanță selectată depășește valoarea maximă acceptată. Vă rugăm să ajustați valorile.',
      3099: 'Nu se poate construi o hartă izocronă pentru punctul (punctele) și profilul selectat(e).',
    },
    genericErrorMsg: 'Nu a fost posibil să se calculeze izocronii.',
    timeoutError: 'Solicitarea a durat prea mult și a fost anulată. Încercați intervale sau intervale mai mici.'
  }
}
